import React from 'react'

var CountryModal = (props) => {
    var introCopy, footerCopy
    switch( props.country ) {
        case 'brazil':
            introCopy = 'Support conservation efforts at an ecological park or at an exotic animal rescue shelter.'
            footerCopy = 'Encompassing half of South America, Brazil is a country of mythic proportions and fascinating cultural fusion.'
            break;
        case 'ecuador':
            introCopy = 'Work with artisan associations to promote their wares, help produce a radio show featuring indigenous voices, or work at the local newspaper.'
            footerCopy = 'This small South American country offers a diversity of wonders. With indigenous villages, picturesque cities, Amazonian rainforests, and the breathtaking heights of the Andes – Ecuador packs a punch!'
            break;
        case 'india':
            introCopy = 'Assist in teaching any level from pre-school to high school students, develop enrichment programs, or tutor locals in English or computer skills.'
            footerCopy = 'A country of cultural dynamism and incredible extremes, India is full of surprises. India occupies the greater part of South Asia - from the snow-capped Himalayas in the north to the sunny beaches of the south.'
            break;
        case 'senegal':
            introCopy = 'Work on an organic farm that teaches sustainable farming, plant and harvest crops, or support agricultural co-ops and farmers markets.'
            footerCopy = 'Senegal lies in Sub-Saharan Africa at the westernmost point of the continent. In Senegal, community is a way of life and the hospitality is even more impressive than the towering baobab trees!'
            break;
    }

    return (
        <div className="countryModal">
            <div className="activeCountry">
                <img src={ `/icons/${props.country}-icon-orange-clean.png` } alt="" />
                <div className="icon">
                    <img src={ `/icons/icon-detail-${props.icon}.svg` } alt=""/>
                </div>
            </div>
            <div className="headline">
                <h1 className="hero-module-headline">{ props.country }</h1>
            </div>
            <div className="content">
                <p>{ introCopy }</p>
            </div>
            <div className="closing">
                <h5 className="orange">{ footerCopy }</h5>
            </div>
            <div className="image-accent-left">
                <img src={ `/icons/mask-${props.country}-1.png` } alt=""/>
            </div>
            <div className="image-accent-right">
                <img src={ `/icons/mask-${props.country}-2.png` } alt=""/>
            </div>
        </div>
    )
}

export default CountryModal



// WEBPACK FOOTER //
// ./src/components/Shared/NewLandingSignup/CountryModal.js